var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.75,
    cy: 12,
    r: 11.5,
    fill: "#ECEEEC",
    stroke: "#5C715E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_39285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9178 7.76794C14.6058 7.45594 14.1018 7.45594 13.7898 7.76794L10.1178 11.4399C9.80579 11.7519 9.80579 12.2559 10.1178 12.5679L13.7898 16.2399C14.1018 16.5519 14.6058 16.5519 14.9178 16.2399C15.2298 15.9279 15.2298 15.4239 14.9178 15.1119L11.8138 11.9999L14.9178 8.89594C15.2298 8.58394 15.2218 8.07194 14.9178 7.76794Z",
    fill: "#5C715E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_39285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(3.1499 2.3999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrev);
export default __webpack_public_path__ + "static/media/arrow_prev.54d6cd361f4ac4080143e25ceb76b998.svg";
export { ForwardRef as ReactComponent };